import React from 'react'
import Contact from './components/Contact'

function Courses() {
  return (
    <div>
       <Contact/>
    </div>
  )
}

export default Courses
